import React from "react";
import { Link } from "react-router-dom";

interface HeaderBottomProps {
  bClass?: string;
}

const HeaderBottom: React.FC<HeaderBottomProps> = ({ bClass }) => {
  const ClickHandler = (): void => {
    window.scrollTo(10, 0);
  };

  return (
    <div className={`header-bottom-style ${bClass || ""}`}>
      <div className="wpo-site-header header-style-s3">
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-1 col-1">
                <div
                  id="navbar2"
                  className="site-navbar collapse navbar-collapse navigation-holder"
                >
                  <button className="menu-close">
                    <i className="ti-close"></i>
                  </button>

                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    {/* 🏠 Home */}
                    <li className="menu-item-has-children">
                      <Link onClick={ClickHandler} to="/">
                        Home
                      </Link>
                      <ul className="sub-menu">
                        <li>
                          <Link onClick={ClickHandler} to="/invitation">
                            Wedding Invitation
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default HeaderBottom;
